import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { RandomQuestion } from '../../../components/common/RandomQuestion';
import { shuffleArray } from '../../../helpers/questionRandom';
import { randomQuestionTheme7 } from '../../../assets/tema7/act_random';
import { voicesTypeControl } from '../../../types/audioType';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	win: 5,
	fail: 6

};

let pointsWin = 0

const stepGame = [
	{
		id: 0,
		title: "Paso 1",
		text: "Presiona la tecla F8.",
		img: randomQuestionTheme7.p1
	},
	{
		id: 1,
		title: "Paso 2",
		text: "Ingresa tu contraseña.",
		img: randomQuestionTheme7.p2
	},
	{
		id: 3,
		title: "Paso 3",
		text: "Cuenta el dinero.",
		img: randomQuestionTheme7.p3
	},
	{
		id: 4,
		title: "Paso 4",
		text: `Imprime el ticket y enfajilla el dinero.`,
		img: randomQuestionTheme7.p4
	},
	{
		id: 5,
		title: "Paso 5",
		text: "Firmas el ticket de quien elabora y quien verifica.",
		img: randomQuestionTheme7.p5
	},
	{
		id: 6,
		title: "Paso 6",
		text: "Deposita fajilla en tómbola.",
		img: randomQuestionTheme7.p6
	},
	{
		id: 7,
		title: "Paso 7",
		text: "Registra: hora, montos, responsable, del retiro y firma del encargado y ayudante.",
		img: randomQuestionTheme7.p7
	},
];

export const Theme7SubtopicTwoActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema7.activities.subtema2], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 7 sub 1 act 3");
			ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad3.sub2a3a01)
	})


	const [numberQuestion, setNumberQuestion] = useState(0);
	const [questionGameOne, setQuestionGameOne] = useState([]);
	const [saveResponsesGameOne, setSaveResponsesGameOne] = useState([]);
	const [responseQuestionGameOne, setResponseQuestionGameOne] = useState([]);


	const checkCorrectsInGameOne = (array = []) => {
		const trueElements = array.filter(element => element === true);
		return trueElements.length >= 3;
	}

	const getRandomQuestionGame = useCallback(() => {
		const newQuestion = shuffleArray(stepGame);
		const questions = newQuestion.slice(0, 5);
		const newResponse = shuffleArray(questions);
		setQuestionGameOne(newQuestion);
		setResponseQuestionGameOne(newResponse);
	}, []);

	useEffect(() => {
		getRandomQuestionGame();
	}, [getRandomQuestionGame]);

	const finishSubactivityOne = (isWin = false) => {
		if (isWin) {
			setUiToShow(steps.win);
		} else {
			setUiToShow(steps.fail);
		}
	};

	const condition = (client) => client.id === questionGameOne[numberQuestion + 1].id;

	const verificationResponse = (selectNumber = -1) => {
		if (selectNumber === -1) {
			return;
		}

		if (numberQuestion + 1 >= questionGameOne.length + 1) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveResponsesGameOne)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* verificar si es correcto
		const isCorrectResponse = questionGameOne[numberQuestion].id === selectNumber;
		const saveGame = [...saveResponsesGameOne, isCorrectResponse];

		if (isCorrectResponse) {
			pointsWin += 10
		}

		if (numberQuestion + 1 === questionGameOne.length) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveGame)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* revolver respuestas
		const matchingObject = stepGame.find(condition);
		const nonMatchingObjects = stepGame.filter((client) => !condition(client));
		const shuffleNonMatchingObjects = shuffleArray(nonMatchingObjects);
		const sliceNonMatchingObjects = shuffleNonMatchingObjects.slice(0, 4);
		sliceNonMatchingObjects.push(matchingObject);
		const shuffleNewResponse = shuffleArray(sliceNonMatchingObjects);


		//* guardar state
		setResponseQuestionGameOne(shuffleNewResponse);
		setNumberQuestion(numberQuestion + 1);
		setSaveResponsesGameOne(saveGame);
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 3);
						pointsWin = 0
						getRandomQuestionGame()
						setNumberQuestion(0)
						setSaveResponsesGameOne([])
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1: Retiro Parcial.' />
					<DialogBarNew
						dialog={`Presta mucha atención al siguiente tema: Si el sistema te muestra una alerta para retirar efectivo esto es lo que significa. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Control de efectivo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad3.sub2a3a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Los retiros de efectivo se realizan de manera continua durante el día, para mantener la caja con una cantidad baja de dinero. El sistema detecta que llego a su limite y te pide retirar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<HeaderRedPresentation name='Ejercicio: Selecciona la opción correcta.' />
					<DialogBarNew
						dialog={`Completa las oraciones con los pasos, para llevar a cabo un retiro parcial de efectivo.`}
						callback={() => {
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === -1 && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<RandomQuestion
						textStyleContainerQuestion={"text-[16px]"}
						action={verificationResponse}
						numberQuestion={numberQuestion}
						arrayQuestion={questionGameOne}
						anserwerQuestion={responseQuestionGameOne}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsWin}
						dialogModal="Has relacionado correctamente los pasos para un retiro parcial de efectivo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsWin,
									subtema: tasksId.tema7.activities.subtema2
								})
							);
							navigator("/home7/tema7/subtema2/activityFour");
						}}
					/>
				</>
			)}

			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						dialogModal="¡Lo siento! parece que tuviste dificultades al completar los pasos para un retiro parcial de efectivo."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsWin,
									subtema: tasksId.tema7.activities.subtema2
								})
							);
							navigator("/home7/tema7/subtema2/activityFour");
						}}
					/>
				</>
			)}

		</>
	)
}
